import { Image } from 'antd'
import { correct_media } from 'general_function'
import React from 'react'

export default function Exercise({ item }) {
    return <div>
        {item.image &&
            <div style={{ margin: "auto", maxWidth: 400 }}>
                <Image src={correct_media(item.image)} />
            </div>}
        <div style={{ whiteSpace: "pre-line" }}>
            {item.content}
        </div>
        {item.need_space_to_answer && 
            <div >
                <div style={{ height: 30, borderBottom: "1px solid #ccc" }}/>
                <div style={{ height: 30, borderBottom: "1px solid #ccc" }}/>
                <div style={{ height: 30, borderBottom: "1px solid #ccc" }}/>
            </div>
        }
    </div>
}